export const treatmentStatusOptions = [
  { id: 1, name: 'Open' },
  { id: 2, name: 'Closed' },
  { id: 3, name: 'Discarded' },
];
